import { API } from "aws-amplify";

async function performStats(geo) {
  const payloadGeo = { ...geo }

  payloadGeo.coordinates = payloadGeo.coordinates[0];

  const payload = {
    body: payloadGeo,
    headers: {},
  };
  let response = await API.post("api", "/run-stats", payload);
  if (response.body) response = response.body;
  if (response.message === "success") return response.data;
  else
    throw new Error(
      response.message ? response.message : response.errorMessage
    );
}

export default performStats;
